<mat-paginator
  [pageSize]="recordsPerPage$ | async"
  [length]="resultCount"
  [hidePageSize]="useCompactLayout$ | async"
  [pageSizeOptions]="pageSizes"
  [pageIndex]="page - 1"
  (page)="onPageChange($event)"
  showFirstLastButtons
></mat-paginator>
